import {
	AfterViewInit,
	ApplicationRef,
	ChangeDetectorRef,
	Component,
	ComponentFactoryResolver,
	ComponentRef,
	EventEmitter,
	inject,
	Injector,
	OnDestroy,
	OnInit,
	ViewContainerRef,
} from '@angular/core';
import * as Leaflet from 'leaflet';
import {
	FormularioRelatorio,
	INPUTS_RELATORIOS,
	InstanciaRelatorio,
	PeriodosLabel,
} from '@home/submodulos/dados-meteorologicos/interfaces/tipos-relatorios';
import { Validators } from '@angular/forms';
import { Select } from '@layout/interfaces/select';
import { HttpClient } from '@angular/common/http';
import { RelatoriosService } from '@home/submodulos/dados-meteorologicos/services/relatorios.service';
import {
	CORES,
	legendaInfoPluvObservadaPeriodoObservada as legendaPeriodo,
	legendaInfoPluvObservada2MesesAAnual as legenda2MesesAAnual,
} from '@componentes/mapa-paraiba-svg/legenda';
import { AgrupamentoResponse } from '@home/submodulos/dados-meteorologicos/interfaces/agrupamento';
import { PopupAgrupamentoComponent } from '@home/submodulos/dados-meteorologicos/componentes/popup-agrupamento/popup-agrupamento.component';
import {
	AgrupamentoGeojson,
	agrupamentoGeojsonMap,
} from '@home/submodulos/dados-meteorologicos/enum/Agrupamento';
import { GroupButton } from '@componentes/public-button-group/public-button-group.component';
import * as pdfseira from '@utils/pdf-seira';
import html2canvas from 'html2canvas';
import * as ExcelTable from 'mr-excel';
import { DataModel } from 'mr-excel';
import { DocumentExporter } from '@utils/document-exporter';
import { DateTimeUtils } from '@utils/datetime-util';
import { ColorUtils } from '@utils/color-utils';
import {
	alinharDado,
	baixarEAbrirPDF,
	enumAsSelectOptions,
	isNotNuloOuUndefined,
	isNuloOuUndefined,
	getIdentifierToBaciaSubBaciaRegioes,
	numberToBrNumberTables,
	verificaSePDFEAdicionaNaTabela,
} from '@utils';
import { corrigeDuplicacaoNome } from '../../../utils';
import { Feature, Geometry } from 'geojson';
import { AgrupamentoEspecial } from '@home/submodulos/dados-meteorologicos/interfaces/relatorioEnum';
import { MenuMapaPluviometriaObservadaComponent } from '../../menu-mapa-pluviometria-observada/menu-mapa-pluviometria-observada.component';
import { CamadasGeojson, camadasGeojsonMap } from '../../../enum/Camadas';
import { StatusEstacao } from '@modulos/meteorologia/submodulos/estacao/enums/status-estacao';
import { Subject, takeUntil } from 'rxjs';
import { NumberUtils } from '@utils/number-utils';
import { HostListener } from '@angular/core';
type GeoWithCoordinates = Geometry & {
	coordinates: number[][][];
};
type MapCapture = {
	dataUrl: string;
	mapRect: { x: number; y: number; w: number; h: number };
	canvasW: number;
	canvasH: number;
};

@Component({
	selector: 'seira-mapa-pluviometria-observada',
	templateUrl: './mapa-pluviometria-observada.component.html',
	styleUrls: ['./mapa-pluviometria-observada.component.scss'],
})
export class MapaPluviometriaObservadaComponent
	implements OnInit, AfterViewInit, OnDestroy, InstanciaRelatorio
{
	map!: Leaflet.Map;
	markersLayer: Leaflet.LayerGroup | any;
	layersCamada = new EventEmitter<Leaflet.GeoJSON[]>();
	carregando = true;
	status: { label: StatusEstacao; value: keyof typeof StatusEstacao }[] = [];
	show = 'block';
	centerDefault: Leaflet.LatLngExpression = [-7.2605416, -36.7290255];
	zoomDefault = 8;
	inputs = inject(INPUTS_RELATORIOS);
	agrupamento: Select[] | any = [];
	geoJsonLayer?: Leaflet.GeoJSON;
	legenda: Record<number, string>;
	menuLateral = new Leaflet.Control({ position: 'bottomright' });
	agrupamentoResult: AgrupamentoResponse[] = [];
	periodoTitulo = '';
	isBacia = false;
	componenteMenu?: ComponentRef<MenuMapaPluviometriaObservadaComponent>;
	TipoVisualizacao: string;
	_destroyed = new Subject<void>();

	@HostListener('window:resize')
	onResize() {
		if (this.map) {
			setTimeout(() => this.map.invalidateSize(), 120);
		}
	}

	private dockCompRef?: ComponentRef<PopupAgrupamentoComponent>;

	descricaoRelatorio =
		'Define-se como pluviometria observada a quantidade total de chuva registrada em um local ou região específica, medida ao longo de um período.';

	ALTO_CURSO = 'Região do Alto Curso do Rio Paraíba';
	BAIXO_CURSO = 'Região do Baixo Curso do Rio Paraíba';
	MEDIO_CURSO = 'Região do Médio Curso do Rio Paraíba';
	private isExporting = false;
	private camadaAtual?: string;
	private readonly exportScale = 2;
	private readonly exportDesktopWidth = 993;
	private readonly exportMapHeight = 500;

	private coordPaneName = 'coordPane';
	private coordOverlayEl?: HTMLDivElement;
	private coordOverlayCleanup?: () => void;
	private compassOverlayEl?: HTMLDivElement;
	private compassOverlayCleanup?: () => void;

	maskLayer?: Leaflet.Polygon;
	private maskPaneName = 'maskPane';

	botoesDeExportacao: GroupButton[] = [
		{
			label: '.png',
			size: 'small',
			icon: 'ph-image',
			onClick: async () => this.exportarPNG(),
		},
		{
			label: '.pdf',
			size: 'small',
			icon: 'ph-file-pdf',
			activeFakeLoading: true,
			onClick: () => this.exportarPDF(),
		},
		{
			label: '.csv',
			size: 'small',
			icon: 'ph-file-csv',
			onClick: () => this.exportarCSV(),
		},
		{
			label: '.txt',
			size: 'small',
			icon: 'ph-file-text',
			onClick: () => this.exportarTXT(),
		},
		{
			label: '.xlsx',
			size: 'small',
			icon: 'ph-file-xls',
			onClick: () => this.exportarXLSX(),
		},
	];
	agrupamentoPluviometriaObsHeader: {
		label: string;
		text: string;
		size: number;
	} = {
		label: '',
		text: '',
		size: 0,
	};

	constructor(
		private resolver: ComponentFactoryResolver,
		private appRef: ApplicationRef,
		private injector: Injector,
		private cdr: ChangeDetectorRef,
		private httpClient: HttpClient,
		private relatorioService: RelatoriosService,
		private viewContainerRef: ViewContainerRef
	) {
		this.agrupamento = enumAsSelectOptions(AgrupamentoEspecial);
		this.setValidators();
	}

	ngOnInit(): void {
		this.inputs.form
			.get(FormularioRelatorio.AGRUPAMENTO)
			?.setValue(this.agrupamento[0].value, { emitEvent: false });

		this.observarValores();
	}

	ngAfterViewInit(): void {
		this.cdr.detectChanges();
	}

	get isAnual(): boolean {
		return (
			this.getFormItemValue(FormularioRelatorio.PERIODO_BUSCA).toUpperCase() ===
			'ANUAL'
		);
	}

	ngOnDestroy(): void {
		this.inputs.form.get(FormularioRelatorio.AGRUPAMENTO)?.clearValidators();
		this.inputs.form.get(FormularioRelatorio.DATA_INICIO)?.clearValidators();
		this.inputs.form.get(FormularioRelatorio.DATA_FIM)?.clearValidators();
		this._destroyed.next();
		this._destroyed.complete();
		if (this.compassOverlayEl) this.compassOverlayEl.remove();
		if (this.compassOverlayCleanup) this.compassOverlayCleanup();
	}

	observarValores() {
		this.inputs.form
			.get(FormularioRelatorio.PERIODO_BUSCA)
			?.valueChanges.pipe(takeUntil(this._destroyed))
			.subscribe({
				next: (periodoValue: string) => {
					if (periodoValue.toUpperCase() === 'ANUAL') {
						const anoAtual = new Date().getFullYear();
						this.inputs.form.patchValue({
							dataInicio: new Date(anoAtual, 0, 1),
							dataFim: new Date(anoAtual, 11, 31),
						});
					}
				},
			});

		this.inputs.form
			.get(FormularioRelatorio.DATA_INICIO)
			?.valueChanges.pipe(takeUntil(this._destroyed))
			.subscribe({
				next: (novaDataInicioValue: Date | string) => {
					if (this.isAnual) {
						const novaDataInicio = new Date(novaDataInicioValue);
						const anoNovaDataInicio = novaDataInicio.getFullYear();
						const dataFimAtual = new Date(
							this.getFormItemValue(FormularioRelatorio.DATA_FIM)
						);

						if (
							dataFimAtual.getFullYear() !== anoNovaDataInicio ||
							dataFimAtual.getMonth() !== 11 ||
							dataFimAtual.getDate() !== 31
						) {
							this.inputs.form.patchValue(
								{
									dataFim: new Date(anoNovaDataInicio, 11, 31),
								},
								{ emitEvent: false }
							);
						}
					}
				},
			});

		this.inputs.form
			.get(FormularioRelatorio.DATA_FIM)
			?.valueChanges.pipe(takeUntil(this._destroyed))
			.subscribe({
				next: (novaDataFimValue: Date | string) => {
					if (
						this.getFormItemValue(
							FormularioRelatorio.PERIODO_BUSCA
						).toUpperCase() === 'ANUAL'
					) {
						const novaDataFim = new Date(novaDataFimValue);
						const anoNovaDataFim = novaDataFim.getFullYear();
						const dataInicioAtual = new Date(
							this.getFormItemValue(FormularioRelatorio.DATA_INICIO)
						);

						if (
							dataInicioAtual.getFullYear() !== anoNovaDataFim ||
							dataInicioAtual.getMonth() !== 0 ||
							dataInicioAtual.getDate() !== 1
						) {
							this.inputs.form.patchValue(
								{
									dataInicio: new Date(anoNovaDataFim, 0, 1),
								},
								{ emitEvent: false }
							);
						}
					}
				},
			});
	}

	setValidators() {
		this.inputs.form
			.get(FormularioRelatorio.AGRUPAMENTO)
			?.setValidators(Validators.required);
		this.inputs.form
			.get(FormularioRelatorio.DATA_INICIO)
			?.setValidators(Validators.required);
		this.inputs.form
			.get(FormularioRelatorio.DATA_FIM)
			?.setValidators(Validators.required);
	}

	gerarRelatorio() {
		const diaInicio = this.getFormItemValue('dataInicio');
		const diaFim = this.getFormItemValue('dataFim');
		const agrupamento = this.getFormItemValue('agrupamento');
		this.isBacia = agrupamento === 'BACIA_SUBBACIA';
		this.agrupamento = agrupamento;
		const periodo = this.getFormItemValue(
			FormularioRelatorio.PERIODO_BUSCA
		) as PeriodosLabel;

		this.atualizaLegenda();
		this.inputs.setLoading(true);
		this.carregando = true;
		this.periodoTitulo = DateTimeUtils.formatarDataPeriodo(
			diaInicio,
			diaFim,
			periodo
		);

		this.relatorioService
			.buscarRelatorioPorAgrupamento({
				diaInicio,
				diaFim,
				agrupamento,
				periodoAgrupamento: periodo.toUpperCase(),
			})
			.subscribe({
				next: (val: AgrupamentoResponse[]) => {
					const todasPrecsSaoNull = val.every(
						el => el.precipitacaoAcumulada === null
					);

					this.relatorioService.atualizaVisibilidadeBotoesExportacao(
						todasPrecsSaoNull ? false : val
					);

					this.agrupamentoResult = this.maioresPreciptacoesPorMunicipio(
						val,
						agrupamento
					);

					this.rebuildIndice();
				},

				error: () => {
					this.carregando = false;
					this.inputs.setLoading(false);
				},
				complete: () => {
					if (this.isBacia) {
						this.getMenu();
					} else {
						if (this.componenteMenu) {
							this.componenteMenu.destroy();
							this.componenteMenu = undefined;
						}

						this.pintarMapa(agrupamento);
					}
					this.carregando = false;
					this.inputs.setLoading(false);
				},
			});
	}
	setupMap(mapa: Leaflet.Map) {
		this.map = mapa;

		this.map.attributionControl?.remove();

		//this.desativarZooms(this.map);

		// ...

		const onResize = () => {
			this.map.invalidateSize(true);
			this.fitMapToBounds();
		};

		window.addEventListener('resize', onResize, { passive: true });

		// limpa no destroy
		this._destroyed.pipe(takeUntil(this._destroyed)).subscribe(); // (não precisa mudar)
		const oldOnDestroy = this.ngOnDestroy.bind(this);
		this.ngOnDestroy = () => {
			window.removeEventListener('resize', onResize);
			oldOnDestroy();
		};

		this.cdr.detectChanges();
	}

	compilePopupAgrupamento(
		onAttach: (el: ComponentRef<PopupAgrupamentoComponent>) => void
	) {
		const compFactory = this.resolver.resolveComponentFactory(
			PopupAgrupamentoComponent
		);
		const compRef = compFactory.create(this.injector);

		if (onAttach) onAttach(compRef);

		this.appRef.attachView(compRef.hostView);
		compRef.onDestroy(() => this.appRef.detachView(compRef.hostView));

		const div = document.createElement('div');
		div.classList.add('popup-agrupamento');
		div.appendChild(compRef.location.nativeElement);
		return div;
	}

	pintarMapa(agrupamento: string, camada?: string) {
		this.setAgrupamentoHeader(agrupamento);
		this.loadMunicipiosMap(this.map, camada);
		this.carregando = true;
		this.inputs.setLoading(false);
	}

	maioresPreciptacoesPorMunicipio(
		val: AgrupamentoResponse[],
		agrupamento: string
	) {
		if (agrupamento === 'MUNICIPIO_POSTO') {
			const acumuladosPorPosto = new Map<string, number | undefined>();
			const municipiosMap = new Map<string, AgrupamentoResponse>();

			val.forEach(estacao => {
				const [municipio, posto] = estacao.nome.split('/');

				const chavePosto = `${municipio}/${posto}`;
				const precipitacaoAtual = estacao.precipitacaoAcumulada;

				const ehOPrimeiroValorPreenchido =
					isNotNuloOuUndefined(precipitacaoAtual) &&
					isNuloOuUndefined(acumuladosPorPosto.get(chavePosto));

				if (ehOPrimeiroValorPreenchido) {
					acumuladosPorPosto.set(chavePosto, precipitacaoAtual);
				} else if (isNotNuloOuUndefined(precipitacaoAtual)) {
					acumuladosPorPosto.set(
						chavePosto,
						acumuladosPorPosto.get(chavePosto)! + precipitacaoAtual
					);
				}
				const municipioAtual = municipiosMap.get(municipio);
				const maiorPrecipitacaoDoMunicipio =
					municipioAtual?.precipitacaoAcumulada ?? 0;

				if (
					acumuladosPorPosto.get(chavePosto)! >= maiorPrecipitacaoDoMunicipio
				) {
					municipiosMap.set(municipio, {
						...estacao,
						precipitacaoAcumulada: acumuladosPorPosto.get(chavePosto)!,
						nomeOriginal: estacao.nome,
						nome: corrigeDuplicacaoNome(chavePosto),
					});
				}
			});

			return Array.from(municipiosMap.values());
		} else {
			return this.handleCalculatePrecipitacaoAcumuladaByResponse(val);
		}
	}

	getGeojsonPorAgrupamento() {
		const agrupamentoKey = this
			.agrupamento as keyof typeof agrupamentoGeojsonMap;
		const agrupamento = agrupamentoGeojsonMap[agrupamentoKey];

		return agrupamento ? agrupamento : AgrupamentoGeojson.MUNICIPIO;
	}

	getGeoJsonPorCamada(camada: string) {
		const geocamada =
			camadasGeojsonMap[camada as keyof typeof camadasGeojsonMap];
		return geocamada ? geocamada : CamadasGeojson.BACIAS;
	}
	loadMunicipiosMap(_map: Leaflet.Map, camada?: string) {
		this.camadaAtual = camada;

		if (this.geoJsonLayer) {
			this.geoJsonLayer.remove();
			this.geoJsonLayer.clearLayers();
		}

		const jsongeo =
			camada === undefined
				? this.getGeojsonPorAgrupamento()
				: this.getGeoJsonPorCamada(camada!);

		const renderer = Leaflet.canvas({ padding: 0.5 });

		this.httpClient.get<GeoJSON.GeoJsonObject>(jsongeo).subscribe({
			next: (value: GeoJSON.GeoJsonObject) => {
				this.garantirPaneCoordenadas(_map);

				this.geoJsonLayer = Leaflet.geoJSON(value, {
					renderer,
					smoothFactor: 1,
					style: (feature?: Feature<Geometry, any>) =>
						this.estiloRegiao(feature as any, camada),
					onEachFeature: (
						feature: Feature<Geometry, any>,
						layer: Leaflet.Layer
					) => {
						layer.on({
							click: (e: Leaflet.LeafletMouseEvent) => {
								const key = this.chavePropriedadeFeatureGeoJSON(
									camada,
									feature
								);
								console.log('props:', feature.properties);

								const nome =
									feature.properties?.[key] ??
									feature.properties?.Nome ??
									feature.properties?.name ??
									feature.properties?.nome ??
									feature.properties?.NM_MESO ??
									feature.properties?.Regiao ??
									'';

								const chave = this.resolverNomeParaBusca(feature, camada);

								const dadosRegiao =
									chave !== this.normalizarNome('Paraíba')
										? this.indiceAgrupamento.get(chave)
										: (() => {
												const cursos = [
													this.ALTO_CURSO,
													this.BAIXO_CURSO,
													this.MEDIO_CURSO,
												];
												const regioes = this.agrupamentoResult.filter(d =>
													cursos.includes(d.nome)
												);
												const total = regioes.reduce(
													(acc, curr) =>
														acc + (curr.precipitacaoAcumulada || 0),
													0
												);
												const media =
													regioes.length > 0 ? total / regioes.length : 0;
												return {
													nome: 'Paraíba',
													precipitacaoAcumulada: media,
													tipo: this.agrupamento as string,
												};
										  })();

								const markerPopup = this.compilePopupAgrupamento(c => {
									const cor = this.getColor(dadosRegiao?.precipitacaoAcumulada);

									if (dadosRegiao) {
										c.instance.agrupamento = {
											...dadosRegiao,
											tipo: this.agrupamento as string,
										};
									} else {
										const geo: GeoWithCoordinates =
											feature.geometry as GeoWithCoordinates;
										const coordenadas = geo.coordinates.flat(1);
										const latitudes: number[] = [];
										const longitudes: number[] = [];

										coordenadas.forEach(([lat, long]) => {
											latitudes.push(lat);
											longitudes.push(long);
										});

										const mediaLatitude =
											latitudes.reduce((a, b) => a + b) / latitudes.length;
										const mediaLongitude =
											longitudes.reduce((a, b) => a + b) / longitudes.length;

										c.instance.agrupamento = {
											latitude: mediaLatitude,
											longitude: mediaLongitude,
											nome:
												feature.properties[
													this.chavePropriedadeFeatureGeoJSON(camada, feature)
												] ?? this.getPropertyNomeGeoson(feature),
											tipo: this.agrupamento as string,
										};
									}

									c.instance.headerColor = cor;
									c.instance.titleColor = ColorUtils.ehCorClara(cor)
										? 'gray'
										: CORES.BRANCO_NEVE;
								});

								layer.bindPopup(markerPopup).openPopup(e.latlng);
							},
						});
					},
				} as any).addTo(_map);

				// 2) bounds uma vez só
				const bounds = this.geoJsonLayer?.getBounds();
				this.fitMapToBounds();
			},
		});
	}

	private chavePropriedadeFeatureGeoJSON(
		camada?: string,
		feature?: Feature<Geometry, any>
	): string {
		switch (this.agrupamento) {
			case 'MUNICIPIO_POSTO':
			case 'MUNICIPIO':
			case 'REGIAO_PLUVIOMETRICA':
				return 'name';
			case 'MICRORREGIAO':
				return 'nome';
			case 'MESORREGIAO':
				return 'NM_MESO';
			case 'BACIA_SUBBACIA':
				if (camada === 'REGIAO_CURSO') {
					return 'Regiao';
				} else if (
					camada === 'BACIA_SUBBACIA_REGIAO' ||
					camada === 'BACIA_SUBBACIA'
				) {
					const bacia = this.agrupamentoResult.find(
						(d: AgrupamentoResponse) => d.nome === feature!.properties['name']
					);
					const subbacia = this.agrupamentoResult.find(
						(d: AgrupamentoResponse) => d.nome === feature!.properties['Nome']
					);
					const regiao = this.agrupamentoResult.find(
						(d: AgrupamentoResponse) => d.nome === feature!.properties['Regiao']
					);

					if (bacia && (!subbacia || true) && (!regiao || true)) {
						return 'name';
					} else if (subbacia && (!bacia || true) && (!regiao || true)) {
						return 'Nome';
					} else if (regiao && (!bacia || true) && (!subbacia || true)) {
						return 'Regiao';
					}
				}
				return 'Nome';

			default:
				return 'Nome';
		}
	}

	private indiceAgrupamento = new Map<string, AgrupamentoResponse>();

	private normalizarNome(v: any): string {
		return (v ?? '')
			.toString()
			.trim()
			.toLowerCase()
			.normalize('NFD')
			.replace(/[\u0300-\u036f]/g, '');
	}

	private resolverNomeParaBusca(
		feature: Feature<Geometry, any>,
		camada?: string
	): string {
		const key = this.chavePropriedadeFeatureGeoJSON(camada, feature);

		const nomeGeo =
			feature.properties?.[key] ??
			feature.properties?.Nome ??
			feature.properties?.name ??
			feature.properties?.nome ??
			feature.properties?.NM_MESO ??
			feature.properties?.Regiao ??
			'';

		if (this.agrupamento === 'MUNICIPIO_POSTO') {
			return this.normalizarNome(nomeGeo);
		}

		if (this.agrupamento === 'BACIA_SUBBACIA' && camada === 'REGIAO_CURSO') {
			return this.normalizarNome(feature.properties?.Regiao ?? nomeGeo);
		}

		return this.normalizarNome(nomeGeo);
	}

	private rebuildIndice() {
		this.indiceAgrupamento.clear();

		for (const d of this.agrupamentoResult ?? []) {
			const base = d?.nome ?? '';

			const municipio = base.split('/')[0];

			this.indiceAgrupamento.set(this.normalizarNome(base), d);
			this.indiceAgrupamento.set(this.normalizarNome(municipio), d);
		}
	}

	atualizaLegenda(): void {
		const tipoPeriodo = this.inputs.form.get(FormularioRelatorio.PERIODO_BUSCA)
			?.value;
		const diaInicio = this.getFormItemValue('dataInicio');
		const diaFim = this.getFormItemValue('dataFim');
		const diffMeses = DateTimeUtils.getDiferencaMesesUTC(
			new Date(diaFim),
			new Date(diaInicio)
		);
		this.legenda =
			(tipoPeriodo === 'mensal' && diffMeses >= 3) || tipoPeriodo === 'anual'
				? legenda2MesesAAnual
				: legendaPeriodo;
	}

	getColor(valor?: number | null): string {
		if (valor === undefined || valor === null) {
			return CORES.CINZA;
		}

		const tipoPeriodo = this.inputs.form.get(FormularioRelatorio.PERIODO_BUSCA)
			?.value as 'diario' | 'mensal' | 'anual';
		const diaInicio = this.getFormItemValue('dataInicio');
		const diaFim = this.getFormItemValue('dataFim');
		const diffMeses = DateTimeUtils.getDiferencaMesesUTC(
			new Date(diaFim),
			new Date(diaInicio)
		);

		const legendaAtiva =
			tipoPeriodo === 'mensal' && diffMeses >= 3
				? legenda2MesesAAnual
				: tipoPeriodo === 'anual'
				? legenda2MesesAAnual
				: legendaPeriodo;

		for (const key of Object.keys(legendaAtiva)
			.map(Number)
			.sort((a, b) => b - a)) {
			if (valor >= key) {
				return legendaAtiva[key];
			}
		}

		return CORES.CINZA;
	}
	getPropertyNomeGeoson(feature: {
		properties: {
			Nome?: string;
			NM_MESO?: string;
			name?: string;
			nome?: string;
			Regiao?: string;
		};
	}) {
		return (
			feature.properties.Nome ||
			feature.properties.name ||
			feature.properties.nome ||
			feature.properties.NM_MESO ||
			feature.properties.Regiao ||
			''
		);
	}

	getDadosPosto(item: AgrupamentoResponse) {
		if (item.dadosPosto) {
			if (item.dadosPosto.microrregiao) {
				return item.dadosPosto.microrregiao;
			} else if (item.dadosPosto.mesorregiao) {
				return item.dadosPosto.mesorregiao;
			} else if (item.dadosPosto.bacia) {
				return item.dadosPosto.bacia;
			} else if (item.dadosPosto.subbacia) {
				return item.dadosPosto.subbacia;
			} else if (item.dadosPosto.regiao) {
				return item.dadosPosto.regiao;
			}
		}
		return item.nome;
	}

	estiloRegiao(feature: any, camada?: string): any {
		const nome =
			feature.properties[
				this.chavePropriedadeFeatureGeoJSON(camada, feature)
			] ?? this.getPropertyNomeGeoson(feature);

		const dadosRegiao =
			nome !== 'Paraíba'
				? this.agrupamentoResult.find(
						(d: AgrupamentoResponse) =>
							d.nome === nome ||
							d.nome === feature.properties['Regiao'] ||
							d.nome.split('/')[0] === nome
				  )
				: (() => {
						const cursos = [
							this.ALTO_CURSO,
							this.BAIXO_CURSO,
							this.MEDIO_CURSO,
						];
						const regioes = this.agrupamentoResult.filter(d =>
							cursos.includes(d.nome)
						);
						const total = regioes.reduce(
							(acc, curr) => acc + (curr.precipitacaoAcumulada || 0),
							0
						);
						const media = regioes.length > 0 ? total / regioes.length : 0;
						return { precipitacaoAcumulada: media };
				  })();

		const valorPrecipitacao = dadosRegiao?.precipitacaoAcumulada;

		const corBase = this.getColor(valorPrecipitacao);
		const corViva = this.corMaisViva(corBase);
		const strokeColor = this.isExporting ? '#000000' : '#546E7A';
		const strokeOpacity = this.isExporting ? 0.6 : 0.65;
		const strokeWeight = this.isExporting ? 1.1 : 1.2;

		const dashArray = this.isExporting ? '1,1' : undefined;

		return {
			fillColor: corViva,

			weight: strokeWeight,
			opacity: strokeOpacity,
			color: strokeColor,

			dashArray,
			lineJoin: 'round',
			lineCap: 'round',
			fillOpacity: 0.95,
		};
	}

	getFormItemValue(formValue: string) {
		return this.inputs.form.get(formValue)?.value;
	}

	getDadosTabelaParaExportacao(dados: AgrupamentoResponse[], isPdf: boolean) {
		const tableData: any[][] = [];
		const colunas: any[] = [];

		if (this.agrupamento !== 'MUNICIPIO_POSTO') {
			colunas.push(
				{
					text: this.agrupamentoPluviometriaObsHeader.text,
					fillColor: '#DCDCDC',
					alignment: 'center',
				},
				{
					text: 'Pluviometria observada (mm)',
					fillColor: '#DCDCDC',
					alignment: 'center',
				},
				{ text: 'Data', fillColor: '#DCDCDC', alignment: 'center' }
			);
		} else {
			colunas.push(
				{ text: 'Município/Posto', fillColor: '#DCDCDC', alignment: 'center' },
				{
					text: 'Pluviometria observada (mm)',
					fillColor: '#DCDCDC',
					alignment: 'center',
				},
				{ text: 'Data', fillColor: '#DCDCDC', alignment: 'center' },
				{ text: 'Latitude', fillColor: '#DCDCDC', alignment: 'center' },
				{ text: 'Longitude', fillColor: '#DCDCDC', alignment: 'center' },
				{ text: 'Mesorregião', fillColor: '#DCDCDC', alignment: 'center' },
				{ text: 'Microrregião', fillColor: '#DCDCDC', alignment: 'center' },
				{
					text: 'Região pluviométrica',
					fillColor: '#DCDCDC',
					alignment: 'center',
				},
				{ text: 'Bacia/Sub-bacia', fillColor: '#DCDCDC', alignment: 'center' },
				{ text: 'Tipo', fillColor: '#DCDCDC', alignment: 'center' }
			);
		}

		verificaSePDFEAdicionaNaTabela(tableData, colunas, isPdf);

		const periodo = this.getFormItemValue(
			FormularioRelatorio.PERIODO_BUSCA
		) as PeriodosLabel;
		const formatoData =
			periodo === 'anual'
				? 'yyyy'
				: periodo === 'mensal'
				? 'MM/yyyy'
				: 'DD/MM/yyyy';

		dados.forEach((item: AgrupamentoResponse) => {
			const data = item.data
				? new Date(item.data?.replace(/\.0/g, '')).toISOString()
				: null;

			const rowData = [];

			if (this.agrupamento === 'MUNICIPIO_POSTO') {
				if (isPdf) {
					rowData.push(
						corrigeDuplicacaoNome(item.nome),
						alinharDado(
							numberToBrNumberTables(item.precipitacaoAcumulada, 1),
							isPdf
						),
						alinharDado(
							data ? DateTimeUtils.formatarDataUTC(data, formatoData) : '-',
							isPdf
						),
						alinharDado(
							numberToBrNumberTables(item.dadosPosto.latitude, 4),
							isPdf
						),
						alinharDado(
							numberToBrNumberTables(item.dadosPosto.longitude, 4),
							isPdf
						),
						alinharDado(item.dadosPosto.mesorregiao ?? '-', isPdf),
						alinharDado(item.dadosPosto.microrregiao ?? '-', isPdf),
						alinharDado(item.dadosPosto.regiao ?? '-', isPdf),
						item.dadosPosto && item.dadosPosto.bacia
							? alinharDado(item.dadosPosto.bacia, isPdf)
							: item.dadosPosto && item.dadosPosto.subbacia
							? alinharDado(item.dadosPosto.subbacia, isPdf)
							: alinharDado('-', isPdf),
						alinharDado(getIdentifierToBaciaSubBaciaRegioes(item), isPdf)
					);
				} else {
					rowData.push(
						corrigeDuplicacaoNome(item.nome),
						numberToBrNumberTables(item.precipitacaoAcumulada, 1),
						data ? DateTimeUtils.formatarDataUTC(data, formatoData) : '-',
						numberToBrNumberTables(item.dadosPosto.latitude, 4),
						numberToBrNumberTables(item.dadosPosto.longitude, 4),
						item.dadosPosto.mesorregiao ?? '-',
						item.dadosPosto.microrregiao ?? '-',
						item.dadosPosto.regiao ?? '-',
						item.dadosPosto && item.dadosPosto.bacia
							? item.dadosPosto.bacia
							: item.dadosPosto && item.dadosPosto.subbacia
							? item.dadosPosto.subbacia
							: '-',
						getIdentifierToBaciaSubBaciaRegioes(item)
					);
				}
			} else {
				if (isPdf) {
					rowData.push(
						alinharDado(this.getDadosPosto(item), isPdf),
						alinharDado(
							numberToBrNumberTables(item.precipitacaoAcumulada, 1),
							isPdf
						),
						alinharDado(
							data ? DateTimeUtils.formatarDataUTC(data, formatoData) : '-',
							isPdf
						)
					);
				} else {
					rowData.push(
						this.getDadosPosto(item),
						numberToBrNumberTables(item.precipitacaoAcumulada, 1),
						data ? DateTimeUtils.formatarDataUTC(data, formatoData) : '-'
					);
				}
			}

			tableData.push(rowData);
		});

		return tableData;
	}

	async getMapImage(): Promise<MapCapture | null> {
		await new Promise(resolve => this.map.whenReady(() => resolve(true)));

		const root = document.getElementById('mapa-legenda');
		if (!root) return null;

		this.isExporting = true;
		root.classList.add('export-mode');
		let restoreMobileLayout: (() => void) | null = null;

		if (this.geoJsonLayer) {
			this.geoJsonLayer.setStyle((feature: any) =>
				this.estiloRegiao(feature, this.camadaAtual)
			);
		}

		const geoJsonAtual = this.geoJsonLayer?.toGeoJSON();
		if (geoJsonAtual) {
			this.aplicarMascaraForaDoMapa(
				geoJsonAtual as GeoJSON.GeoJsonObject,
				this.map
			);
		}

		this.aplicarCoordenadas(this.map);
		this.renderizarCoordenadasNoMapa(this.map, this.geoJsonLayer?.getBounds());

		this.aplicarRosaDosVentos(this.map);
		this.renderizarRosaDosVentos();

		try {
			restoreMobileLayout = await this.ajustarLayoutMobileParaExportacao(root);

			await this.esperarRenderizacaoMapa();

			const canvas = await html2canvas(root, {
				useCORS: true,
				allowTaint: true,
				logging: false,
				scale: this.exportScale,
				windowWidth: window.innerWidth < 1200
					? this.exportDesktopWidth
					: window.innerWidth,
			});

			const leafletEl = root.querySelector(
				'.leaflet-container'
			) as HTMLElement | null;
			if (!leafletEl) return null;

			const rootRect = root.getBoundingClientRect();
			const mapRectDom = leafletEl.getBoundingClientRect();

			const relLeft = mapRectDom.left - rootRect.left;
			const relTop = mapRectDom.top - rootRect.top;

			return {
				dataUrl: canvas.toDataURL('image/png', 1),
				canvasW: canvas.width,
				canvasH: canvas.height,
				mapRect: {
					x: relLeft * this.exportScale,
					y: relTop * this.exportScale,
					w: mapRectDom.width * this.exportScale,
					h: mapRectDom.height * this.exportScale,
				},
			};
		} finally {
			if (restoreMobileLayout) restoreMobileLayout();
			this.fitMapToBounds();
			this.removerMascaraDoMapa();
			this.removerOverlays();
			this.isExporting = false;
			root.classList.remove('export-mode');
			if (this.geoJsonLayer) {
				this.geoJsonLayer.setStyle((feature: any) =>
					this.estiloRegiao(feature, this.camadaAtual)
				);
			}
		}
	}

	private async ajustarLayoutMobileParaExportacao(
		root: HTMLElement
	): Promise<(() => void) | null> {
		if (window.innerWidth >= 1200) return null;

		const mapaWrapper = root.querySelector(
			'.mapa-wrapper'
		) as HTMLElement | null;
		const mapaLeaflet = root.querySelector(
			'.leaflet-container'
		) as HTMLElement | null;

		const rootPrev = {
			width: root.style.width,
			minWidth: root.style.minWidth,
			maxWidth: root.style.maxWidth,
		};

		const wrapperPrev = mapaWrapper
			? {
					height: mapaWrapper.style.height,
					minHeight: mapaWrapper.style.minHeight,
			  }
			: null;

		const leafletPrev = mapaLeaflet
			? {
					height: mapaLeaflet.style.height,
			  }
			: null;

		root.style.width = `${this.exportDesktopWidth}px`;
		root.style.minWidth = `${this.exportDesktopWidth}px`;
		root.style.maxWidth = `${this.exportDesktopWidth}px`;

		if (mapaWrapper) {
			mapaWrapper.style.height = `${this.exportMapHeight}px`;
			mapaWrapper.style.minHeight = `${this.exportMapHeight}px`;
		}

		if (mapaLeaflet) {
			mapaLeaflet.style.height = `${this.exportMapHeight}px`;
		}

		this.map.invalidateSize(true);
		await this.esperarRenderizacaoMapa();

		return () => {
			root.style.width = rootPrev.width;
			root.style.minWidth = rootPrev.minWidth;
			root.style.maxWidth = rootPrev.maxWidth;

			if (mapaWrapper && wrapperPrev) {
				mapaWrapper.style.height = wrapperPrev.height;
				mapaWrapper.style.minHeight = wrapperPrev.minHeight;
			}

			if (mapaLeaflet && leafletPrev) {
				mapaLeaflet.style.height = leafletPrev.height;
			}

			this.map.invalidateSize(true);
		};
	}

	private async esperarRenderizacaoMapa() {
		await new Promise<void>(r => requestAnimationFrame(() => r()));
		await new Promise<void>(r => requestAnimationFrame(() => r()));
		await new Promise<void>(r => setTimeout(() => r(), 100));
	}

	setAgrupamentoHeader(agrupamento: string) {
		agrupamento === 'MUNICIPIO_POSTO'
			? (this.agrupamentoPluviometriaObsHeader = {
					label: 'municipio/posto',
					text: 'Município/Posto',
					size: 48,
			  })
			: agrupamento === 'BACIA_SUBBACIA'
			? (this.agrupamentoPluviometriaObsHeader = {
					label: 'baciaSubbacia',
					text: 'Bacia/Sub-bacia',
					size: 48,
			  })
			: agrupamento === 'MESORREGIAO'
			? (this.agrupamentoPluviometriaObsHeader = {
					label: 'mesorregiao',
					text: 'Mesorregião',
					size: 48,
			  })
			: agrupamento === 'MICRORREGIAO'
			? (this.agrupamentoPluviometriaObsHeader = {
					label: 'microrregiao',
					text: 'Microrregião',
					size: 48,
			  })
			: agrupamento === 'MUNICIPIO'
			? (this.agrupamentoPluviometriaObsHeader = {
					label: 'municipio',
					text: 'Município',
					size: 48,
			  })
			: agrupamento === 'REGIAO_PLUVIOMETRICA'
			? (this.agrupamentoPluviometriaObsHeader = {
					label: 'regiao',
					text: 'Região Pluviométrica',
					size: 48,
			  })
			: (this.agrupamentoPluviometriaObsHeader = {
					label: '',
					text: '',
					size: 0,
			  });
	}

	getHeaders(): Array<{ label: string; text: string; size: number }> {
		const headers: Array<{ label: string; text: string; size: number }> = [];

		if (this.agrupamento !== 'MUNICIPIO_POSTO') {
			headers.push(
				this.agrupamentoPluviometriaObsHeader,
				{
					label: 'precipitacaoAcumulada',
					text: 'Pluviometria observada (mm)',
					size: 24,
				},
				{ label: 'data', text: 'Data', size: 24 }
			);
		} else {
			headers.push(
				{
					label: 'nome',
					text: 'Município/Posto',
					size: 48,
				},
				{
					label: 'precipitacaoAcumulada',
					text: 'Pluviometria observada (mm)',
					size: 24,
				},
				{ label: 'data', text: 'Data', size: 24 },
				{ label: 'latitude', text: 'Latitude', size: 24 },
				{ label: 'longitude', text: 'Longitude', size: 24 },
				{
					label: 'mesorregiao',
					text: 'Mesorregião',
					size: 24,
				},
				{ label: 'microrregiao', text: 'Microrregião', size: 24 },
				{ label: 'municipio', text: 'Município', size: 24 },
				{ label: 'regiao', text: 'Região pluviométrica', size: 24 },
				{ label: 'baciaSubbacia', text: 'Bacia/Sub-bacia', size: 24 },
				{ label: 'tipo', text: 'Tipo', size: 24 }
			);
		}

		return headers;
	}

	async exportarPDF() {
		this.map.setView(this.centerDefault, this.zoomDefault);
		await new Promise(resolve => setTimeout(resolve, 750));

		try {
			this.esconderElementosDaExportacao();

			await new Promise(resolve => setTimeout(resolve, 250));

			const tableData = this.getDadosTabelaParaExportacao(
				this.agrupamentoResult,
				true
			);
			const documentDefinition: any = await pdfseira.documentDefinitions();

			const capture = await this.getMapImage();
			if (!capture) {
				console.error('Não foi possível capturar a imagem do mapa.');
				return;
			}

			const imgDataUrl = await this.montarMapaComLogos(capture, {
				showHeader: false,
				showPeriodo: false,
			});

			documentDefinition.content.push([
				{
					text: `Pluviometria (mm) - ${this.periodoTitulo}`,
					alignment: 'center',
					margin: [0, 6, 0, 6],
				},
				{
					image: imgDataUrl,
					fit: [500, 400],
					alignment: 'center',
					margin: [0, -8, 0, 0],
				},
			]);

			const widthsTable =
				this.agrupamento === 'MUNICIPIO_POSTO'
					? ['10%', '10%', '10%', '10%', '10%', '*', '*', '*', '*', '*']
					: ['40%', '30%', '30%'];

			documentDefinition.content.push(
				{ text: '', alignment: 'center', fontSize: 10, margin: [0, 0, 0, 10] },
				{
					table: { widths: widthsTable, body: tableData, layout: {} },
					fontSize: 7,
					marginLeft: 0,
				}
			);

			baixarEAbrirPDF(
				`Pluviometria (mm) - ${this.periodoTitulo}`,
				documentDefinition
			);
		} finally {
			this.mostrarElementosDaExportacao();
		}
	}

	exportarCSV() {
		const tableData = this.getDadosTabelaParaExportacao(
			this.agrupamentoResult,
			false
		);

		DocumentExporter.gerarCSV(
			tableData,
			`Pluviometria (mm) - ${this.periodoTitulo}`
		);
	}

	exportarTXT() {
		const tableData = this.getDadosTabelaParaExportacao(
			this.agrupamentoResult,
			false
		);

		let txtData = '';
		if (tableData.length > 0) {
			const colunas = tableData[0];

			tableData.slice(1).forEach(dadoRelatorio => {
				colunas.forEach((coluna: string, index: number) => {
					const valor = dadoRelatorio[index];
					txtData += `${coluna}: ${valor ?? '-'}\n`;
				});

				txtData += '\n';
			});
		}

		DocumentExporter.gerarTXT(
			txtData,
			`Pluviometria (mm) - ${this.periodoTitulo}`
		);
	}

	exportarXLSX() {
		const nomeArquivo = `Pluviometria (mm) - ${this.periodoTitulo}`;
		const agrupamentoAtual = this.getFormItemValue('agrupamento');

		const colorPalette = {
			c1: '2C3639',
			c2: 'FFFFFF',
			c3: '000000',
			c4: 'EEEEEE',
		};

		const rowStyle = {
			backgroundColor: colorPalette.c2,
			color: colorPalette.c3,
		};
		const headerStyle = {
			backgroundColor: colorPalette.c4,
			color: colorPalette.c1,
			bold: true,
		};
		const headerStyleCenter = {
			backgroundColor: colorPalette.c4,
			color: colorPalette.c1,
			bold: true,
			alignment: {
				horizontal: 'center',
				vertical: 'center',
			} as DataModel.AlignmentOption,
		};
		const rowStyleCenter = {
			backgroundColor: colorPalette.c2,
			color: colorPalette.c3,
			alignment: {
				horizontal: 'center',
				vertical: 'center',
			} as DataModel.AlignmentOption,
		};

		const title = {
			backgroundColor: colorPalette.c2,
			whiteSpace: 'pre' as const,
			color: colorPalette.c3,
			bold: true,
			alignment: {
				horizontal: 'center',
				vertical: 'center',
				wrapText: 1 as 0 | 1,
			} as DataModel.AlignmentOption,
		};

		const headers = this.getHeaders();
		const dataExcel = {
			styles: {
				headerStyle,
				headerStyleCenter,
				rowStyle,
				rowStyleCenter,
				title,
			},
			sheet: [
				{
					shiftTop: 3,
					images: [
						{
							url: 'assets/images/cabecalho/cabeçalho_excel.png',
							from: 'A1',
							to: 'C3',
						},
					],

					styleCellCondition(
						data: any,
						object: any,
						rowIndex: number,
						colIndex: number,
						fromHeader: boolean
					) {
						if (fromHeader) {
							return 'headerStyleCenter';
						}
						if (colIndex === 0 && agrupamentoAtual === 'MUNICIPIO_POSTO') {
							return 'rowStyle';
						}
						return 'rowStyleCenter';
					},
					headers: headers,
					data: this.agrupamentoResult
						.filter(agrupamento => agrupamento)
						.map(agrupamento => {
							const periodo = this.getFormItemValue(
								FormularioRelatorio.PERIODO_BUSCA
							) as PeriodosLabel;
							const formatoData =
								periodo === 'anual'
									? 'yyyy'
									: periodo === 'mensal'
									? 'MM/yyyy'
									: 'DD/MM/yyyy';
							const data = agrupamento.data
								? new Date(agrupamento.data?.replace(/\.0/g, '')).toISOString()
								: '';
							let dataExportada: string | number;

							if (isNuloOuUndefined(data)) {
								dataExportada = '-';
							} else {
								dataExportada = DateTimeUtils.formatarDataUTC(
									data,
									formatoData
								);
								if (this.isAnual) {
									dataExportada = Number(dataExportada);
								}
							}

							if (this.agrupamento === 'MUNICIPIO_POSTO') {
								return {
									nome: corrigeDuplicacaoNome(agrupamento.nome),
									precipitacaoAcumulada: isNuloOuUndefined(
										agrupamento.precipitacaoAcumulada
									)
										? '-'
										: NumberUtils.getIgnorandoCasasDecimais(
												agrupamento.precipitacaoAcumulada
										  ),
									data: dataExportada,
									latitude: isNuloOuUndefined(agrupamento.dadosPosto.latitude)
										? '-'
										: NumberUtils.getIgnorandoCasasDecimais(
												agrupamento.dadosPosto.latitude,
												4
										  ),
									longitude: isNuloOuUndefined(agrupamento.dadosPosto.longitude)
										? '-'
										: NumberUtils.getIgnorandoCasasDecimais(
												agrupamento.dadosPosto.longitude
										  ),
									mesorregiao: agrupamento.dadosPosto.mesorregiao ?? '-',
									microrregiao: agrupamento.dadosPosto.microrregiao ?? '-',
									municipio: agrupamento.dadosPosto.municipio ?? '-',
									regiao: agrupamento.dadosPosto.regiao ?? '-',
									baciaSubbacia:
										agrupamento.dadosPosto.bacia ??
										agrupamento.dadosPosto.subbacia ??
										'-',
									tipo: getIdentifierToBaciaSubBaciaRegioes(agrupamento),
								};
							} else {
								const nomeExibicao = this.getDadosPosto(agrupamento);
								const baseReturn: any = {
									nome: nomeExibicao,
									precipitacaoAcumulada: isNuloOuUndefined(
										agrupamento.precipitacaoAcumulada
									)
										? '-'
										: NumberUtils.getIgnorandoCasasDecimais(
												agrupamento.precipitacaoAcumulada
										  ),
									data: data
										? DateTimeUtils.formatarDataUTC(data, formatoData)
										: '-',
								};
								if (this.agrupamento === 'MESORREGIAO')
									baseReturn.mesorregiao = nomeExibicao;
								if (this.agrupamento === 'MICRORREGIAO')
									baseReturn.microrregiao = nomeExibicao;
								if (this.agrupamento === 'MUNICIPIO')
									baseReturn.municipio = nomeExibicao;
								if (this.agrupamento === 'REGIAO_PLUVIOMETRICA')
									baseReturn.regiao = nomeExibicao;
								if (this.agrupamento === 'BACIA_SUBBACIA')
									baseReturn.baciaSubbacia = nomeExibicao;

								return baseReturn;
							}
						}),
					columns: headers.map(h => ({
						key: h.label,
						style:
							h.label === 'precipitacaoAcumulada'
								? { numFmt: '0.0' }
								: undefined,
					})),
					title: {
						consommeRow: 3,
						consommeCol: headers.length > 3 ? 3 : headers.length,
						text: `${nomeArquivo}`,
						styleId: 'title',
					},
				},
			],
			fileName: nomeArquivo,
		};

		ExcelTable.generateExcel(dataExcel);
	}

	private handleCalculatePrecipitacaoAcumuladaByResponse(
		response: AgrupamentoResponse[]
	): AgrupamentoResponse[] {
		const mapResponse = new Map<string, AgrupamentoResponse>();

		response.forEach(value => {
			const nome = value.nome.split('/')[0];
			const agrupamento = mapResponse.get(nome) ?? {
				...value,
				nome: nome,
				precipitacaoAcumulada: null,
			};
			if (isNotNuloOuUndefined(value.precipitacaoAcumulada)) {
				agrupamento.precipitacaoAcumulada =
					(agrupamento.precipitacaoAcumulada ?? 0) +
					value.precipitacaoAcumulada;
			}
			mapResponse.set(nome, agrupamento);
		});

		return Array.from(mapResponse.values());
	}

	getMenu() {
		if (this.geoJsonLayer) {
			this.geoJsonLayer.remove();
			this.geoJsonLayer.clearLayers();
		}

		if (this.componenteMenu) {
			this.componenteMenu.destroy();
			this.componenteMenu = undefined;
		}

		if (!this.componenteMenu && this.isBacia) {
			this.menuLateral.onAdd = (map: Leaflet.Map) => {
				this.componenteMenu = this.viewContainerRef.createComponent(
					MenuMapaPluviometriaObservadaComponent
				);
				this.componenteMenu.instance.map = map;
				this.componenteMenu.instance.gerarRelatorio
					.pipe(takeUntil(this._destroyed))
					.subscribe(value => {
						this.componenteMenu!.instance.isLoadingMap = true;
						this.componenteMenu!.changeDetectorRef.detectChanges();
						this.carregando = true;
						this.pintarMapa(this.agrupamento as string, value);
						setTimeout(() => {
							this.carregando = false;
							this.componenteMenu!.instance.isLoadingMap = false;
							this.componenteMenu!.changeDetectorRef.detectChanges();
						}, 2350);
					});
				return this.componenteMenu.location.nativeElement;
			};
			this.menuLateral.addTo(this.map);
		}
	}
	private resolveAsset(path: string) {
		return new URL(path, document.baseURI).toString();
	}

	private carregarImagem(src: string): Promise<HTMLImageElement> {
		return new Promise((resolve, reject) => {
			const image = new Image();
			image.crossOrigin = 'anonymous';
			image.onload = () => resolve(image);
			image.onerror = err => reject(err);
			image.src = src;
		});
	}

	private async montarMapaComLogos(
		capture: MapCapture,
		opts?: { showHeader?: boolean; showPeriodo?: boolean }
	): Promise<string> {
		const showHeader = opts?.showHeader ?? true;
		const showPeriodo = opts?.showPeriodo ?? true;

		const logoGovernoSrc = this.resolveAsset(
			'assets/images/logos/governo_pb.png'
		);
		const logoAesaSrc = this.resolveAsset('assets/images/logos/logoAesa.svg');

		const results = await Promise.allSettled([
			this.carregarImagem(capture.dataUrl),
			this.carregarImagem(logoGovernoSrc),
			this.carregarImagem(logoAesaSrc),
		]);

		const mapImage =
			results[0].status === 'fulfilled' ? results[0].value : null;
		const logoGov = results[1].status === 'fulfilled' ? results[1].value : null;
		const logoAesa =
			results[2].status === 'fulfilled' ? results[2].value : null;

		if (!mapImage) return capture.dataUrl;

		const offsetY = 200;

		const canvas = document.createElement('canvas');
		canvas.width = mapImage.naturalWidth;
		canvas.height = mapImage.naturalHeight + offsetY;

		const ctx = canvas.getContext('2d')!;
		ctx.fillStyle = '#ffffff';
		ctx.fillRect(0, 0, canvas.width, canvas.height);

		ctx.drawImage(mapImage, 0, offsetY);
		const mapX0 = capture.mapRect.x;
		const mapY0 = offsetY + capture.mapRect.y;
		const mapX1 = mapX0 + capture.mapRect.w;

		const insidePad = 75;
		const maxLogoHInside = Math.round(Math.min(70, capture.mapRect.h * 0.12));

		const drawLogoInside = (imgEl: HTMLImageElement, x: number, y: number) => {
			const ratio = imgEl.naturalWidth / imgEl.naturalHeight;
			const h = maxLogoHInside;
			const w = Math.round(h * ratio);

			ctx.closePath();
			ctx.fill();
			ctx.stroke();
			ctx.restore();

			ctx.drawImage(imgEl, x, y, w, h);
		};

		const mapY1 = mapY0 + capture.mapRect.h;

		const hLogo = maxLogoHInside;

		const govDx = -105;
		const govDy = -30;

		const aesaDx = 91;
		const aesaDy = -30;

		if (logoGov) {
			const wG = Math.round(
				hLogo * (logoGov.naturalWidth / logoGov.naturalHeight)
			);
			drawLogoInside(
				logoGov,
				mapX1 - insidePad - wG + govDx,
				mapY1 - insidePad - hLogo + govDy
			);
		}

		if (logoAesa) {
			const wA = Math.round(
				hLogo * (logoAesa.naturalWidth / logoAesa.naturalHeight)
			);
			drawLogoInside(
				logoAesa,
				mapX0 + insidePad + aesaDx,
				mapY1 - insidePad - hLogo + aesaDy
			);
		}

		let headerH = 0;

		if (showHeader) {
			headerH = Math.max(52, Math.min(90, Math.round(canvas.height * 0.085)));

			ctx.save();

			ctx.fillStyle = 'rgba(255,255,255,0.92)';
			ctx.fillRect(0, 0, canvas.width, headerH);

			ctx.strokeStyle = 'rgba(17,24,39,0.12)';
			ctx.lineWidth = 1;
			ctx.beginPath();
			ctx.moveTo(0, headerH - 0.5);
			ctx.lineTo(canvas.width, headerH - 0.5);
			ctx.stroke();

			const titulo = 'Pluviometria Observada (mm)';
			const periodo = this.periodoTitulo ?? '';

			ctx.textAlign = 'center';
			ctx.textBaseline = 'middle';

			const font1 = Math.max(24, Math.min(36, Math.round(headerH * 0.5)));
			const font2 = Math.max(24, Math.min(36, Math.round(headerH * 0.5)));

			ctx.fillStyle = '#111827';
			ctx.font = `700 ${font1}px Poppins, Arial, sans-serif`;
			ctx.fillText(titulo, canvas.width / 2, headerH * 1.8);

			if (showPeriodo && periodo.trim()) {
				ctx.font = `600 ${font2}px Poppins, Arial, sans-serif`;
				ctx.fillText(periodo, canvas.width / 2, headerH * 2.3);
			}

			ctx.restore();
		}

		const padX = Math.round(canvas.width * 0.15);
		const padY = Math.round(headerH * 0.5);
		const maxLogoH = Math.round(headerH * 0.7);

		const drawLogo = (
			imgEl: HTMLImageElement,
			x: number,
			align: 'left' | 'right'
		) => {
			const ratio = imgEl.naturalWidth / imgEl.naturalHeight;
			const h = maxLogoH;
			const w = Math.round(h * ratio);

			const y = padY + Math.round((maxLogoH - h) / 2);

			const xFinal = align === 'left' ? x : x - w;

			const badgePad = 6;
			ctx.save();
			ctx.fillStyle = 'rgba(255,255,255,0.92)';
			ctx.strokeStyle = 'rgba(17,24,39,0.10)';
			ctx.lineWidth = 1;
			const bx = xFinal - badgePad;
			const by = y - badgePad;
			const bw = w + badgePad * 2;
			const bh = h + badgePad * 2;

			const r = 8;
			ctx.beginPath();
			ctx.moveTo(bx + r, by);
			ctx.lineTo(bx + bw - r, by);
			ctx.quadraticCurveTo(bx + bw, by, bx + bw, by + r);
			ctx.lineTo(bx + bw, by + bh - r);
			ctx.quadraticCurveTo(bx + bw, by + bh, bx + bw - r, by + bh);
			ctx.lineTo(bx + r, by + bh);
			ctx.quadraticCurveTo(bx, by + bh, bx, by + bh - r);
			ctx.lineTo(bx, by + r);
			ctx.quadraticCurveTo(bx, by, bx + r, by);
			ctx.closePath();
			ctx.fill();
			ctx.stroke();
			ctx.restore();

			ctx.drawImage(imgEl, xFinal, y, w, h);
		};

		return canvas.toDataURL('image/png', 1);
	}

	private downloadDataUrl(nomeArquivoSemExt: string, dataUrl: string) {
		const a = document.createElement('a');
		a.href = dataUrl;
		a.download = `${nomeArquivoSemExt}.png`;
		a.style.display = 'none';
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
	}
	private get nomeExportacaoBase(): string {
		return `Pluviometria Observada (mm) - ${this.periodoTitulo}`;
	}

	async exportarPNG() {
		this.map.setView(this.centerDefault, this.zoomDefault);
		await new Promise(r => setTimeout(r, 750));

		try {
			this.esconderElementosDaExportacao();

			await new Promise(r => setTimeout(r, 200));

			const capture = await this.getMapImage();
			if (!capture) {
				console.error('Não foi possível capturar a imagem do mapa.');
				return;
			}

			const nome = this.nomeExportacaoBase;

			try {
				const dataUrlFinal = await this.montarMapaComLogos(capture);

				const offsetY = 200;
				const recortado = await this.recortarDataUrlSides(
					dataUrlFinal,
					{
						x: capture.mapRect.x,
						y: offsetY + capture.mapRect.y,
						w: capture.mapRect.w,
						h: capture.mapRect.h,
					},
					{ bottom: 220, top: 80, left: -50, right: -50 }
				);

				this.downloadDataUrl(nome, recortado);
			} catch (e) {
				console.error('[Export PNG] Erro ao recortar:', e);
				this.downloadDataUrl(nome, capture.dataUrl);
			}
		} finally {
			this.mostrarElementosDaExportacao();
		}
	}
	private hexToHsl(hex: string) {
		const c = hex.replace('#', '').trim();
		const r = parseInt(c.substring(0, 2), 16) / 255;
		const g = parseInt(c.substring(2, 4), 16) / 255;
		const b = parseInt(c.substring(4, 6), 16) / 255;

		const max = Math.max(r, g, b),
			min = Math.min(r, g, b);
		let h = 0,
			s = 0;
		const l = (max + min) / 2;

		if (max !== min) {
			const d = max - min;
			s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

			switch (max) {
				case r:
					h = (g - b) / d + (g < b ? 6 : 0);
					break;
				case g:
					h = (b - r) / d + 2;
					break;
				case b:
					h = (r - g) / d + 4;
					break;
			}
			h /= 6;
		}

		return { h, s, l };
	}

	private hslToHex(h: number, s: number, l: number) {
		const hue2rgb = (p: number, q: number, t: number) => {
			if (t < 0) t += 1;
			if (t > 1) t -= 1;
			if (t < 1 / 6) return p + (q - p) * 6 * t;
			if (t < 1 / 2) return q;
			if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
			return p;
		};

		let r: number, g: number, b: number;

		if (s === 0) {
			r = g = b = l;
		} else {
			const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
			const p = 2 * l - q;
			r = hue2rgb(p, q, h + 1 / 3);
			g = hue2rgb(p, q, h);
			b = hue2rgb(p, q, h - 1 / 3);
		}

		const toHex = (x: number) =>
			Math.round(x * 255)
				.toString(16)
				.padStart(2, '0');
		return `#${toHex(r)}${toHex(g)}${toHex(b)}`.toUpperCase();
	}

	private corMaisViva(hex: string) {
		if (!hex || !hex.startsWith('#') || hex.length !== 7) return hex;

		const { h, s, l } = this.hexToHsl(hex);

		const s2 = Math.min(1, s * 1.25 + 0.08);
		const l2 = Math.max(0, Math.min(1, l * 0.98));

		return this.hslToHex(h, s2, l2);
	}
	private aplicarMascaraForaDoMapa(
		geo: GeoJSON.GeoJsonObject,
		map: Leaflet.Map
	) {
		if (this.maskLayer) {
			this.maskLayer.remove();
			this.maskLayer = undefined;
		}

		if (!map.getPane(this.maskPaneName)) {
			map.createPane(this.maskPaneName);
			const pane = map.getPane(this.maskPaneName)!;
			pane.style.zIndex = '350';
			pane.style.pointerEvents = 'none';
		}

		const holes: Leaflet.LatLngExpression[][] = [];

		const addPolygonOuterRingAsHole = (coords: any) => {
			if (!Array.isArray(coords) || !Array.isArray(coords[0])) return;

			const ring = coords[0] as [number, number][];
			const latlngs: Leaflet.LatLngExpression[] = ring.map(([lng, lat]) => [
				lat,
				lng,
			]);
			holes.push(latlngs);
		};

		const g: any = geo;

		if (g?.type === 'FeatureCollection' && Array.isArray(g.features)) {
			for (const f of g.features) {
				const geom = f?.geometry;
				if (!geom) continue;

				if (geom.type === 'Polygon') {
					addPolygonOuterRingAsHole(geom.coordinates);
				} else if (geom.type === 'MultiPolygon') {
					for (const polyCoords of geom.coordinates) {
						addPolygonOuterRingAsHole(polyCoords);
					}
				}
			}
		}

		const outer: Leaflet.LatLngExpression[] = [
			[90, -180],
			[90, 180],
			[-90, 180],
			[-90, -180],
		];

		this.maskLayer = Leaflet.polygon([outer, ...holes], {
			pane: this.maskPaneName,
			stroke: false,
			fillColor: '#FFFFFF',
			fillOpacity: 1,

			interactive: false,
		}).addTo(map);
	}

	private garantirPaneCoordenadas(map: Leaflet.Map) {
		if (!map.getPane(this.coordPaneName)) {
			map.createPane(this.coordPaneName);
		}

		const pane = map.getPane(this.coordPaneName)!;

		pane.style.zIndex = '999';
		pane.style.pointerEvents = 'none';

		pane.style.position = 'absolute';
		pane.style.inset = '0';
		pane.style.width = '100%';
		pane.style.height = '100%';
	}

	private readonly coordenadasRef: {
		eixoVertical: Array<{ lat: number; label: string }>;
		eixoHorizontal: Array<{ lng: number; label: string }>;
	} = {
		eixoVertical: [
			{ lat: -5.9, label: '6.0° S' },
			{ lat: -6.5, label: '6,5° S' },
			{ lat: -7.0, label: '7,0° S' },
			{ lat: -7.5, label: '7,5° S' },
			{ lat: -8.0, label: '8,0° S' },
			{ lat: -8.4, label: '' },
		],
		eixoHorizontal: [
			//{ lng: -39.0, label: '39.0° W' },//
			{ lng: -38.5, label: '38,5° W' },
			{ lng: -38.0, label: '38,0° W' },
			{ lng: -37.5, label: '37.5° W' },
			{ lng: -37.0, label: '37,0° W' },
			{ lng: -36.5, label: '36,5° W' },
			{ lng: -36.0, label: '36,0° W' },
			{ lng: -35.5, label: '35,5° W' },
			{ lng: -35.0, label: '35,0° W' },
			//{ lng: -34.5, label: '34,75° W' },//
		],
	};

	private aplicarCoordenadas(map: Leaflet.Map) {
		if (this.coordOverlayEl) this.coordOverlayEl.remove();
		if (this.coordOverlayCleanup) this.coordOverlayCleanup();

		const container = map.getContainer() as HTMLElement;
		if (getComputedStyle(container).position === 'static') {
			container.style.position = 'relative';
		}

		const overlay = document.createElement('div');
		overlay.className = 'mapa-coordenadas-overlay';

		overlay.style.position = 'absolute';
		overlay.style.inset = '0';
		overlay.style.pointerEvents = 'none';
		overlay.style.overflow = 'hidden';
		overlay.style.zIndex = '9999';

		container.appendChild(overlay);
		this.coordOverlayEl = overlay;

		const render = () => {
			const b = this.geoJsonLayer?.getBounds();
			this.renderizarCoordenadasNoMapa(map, b);
		};

		map.whenReady(() => render());
		map.on('resize', render);
		map.on('moveend', render);
		map.on('zoomend', render);

		this.coordOverlayCleanup = () => {
			map.off('resize', render);
			map.off('moveend', render);
			map.off('zoomend', render);
		};
	}

	private renderizarCoordenadasNoMapa(
		map: Leaflet.Map,
		_bounds?: Leaflet.LatLngBounds
	) {
		if (!this.coordOverlayEl) return;

		const size = map.getSize();
		if (!size || size.x < 50 || size.y < 50) return;

		const b = _bounds ?? map.getBounds();
		const center = b.getCenter();

		const gutterLeft = 74;
		const padTop = 14;
		const padRight = 84;
		const padBottom = 18;

		const axisX = gutterLeft;
		const axisTop = padTop;
		const axisRight = size.x - padRight;

		const latBaseEixoX =
			this.coordenadasRef.eixoVertical[
				this.coordenadasRef.eixoVertical.length - 1
			]?.lat ?? -8.39;

		const yBaseRaw = map.latLngToContainerPoint([latBaseEixoX, center.lng]).y;
		const lineColor = this.isExporting ? 'rgba(0,0,0,1)' : 'rgba(0,0,0,.28)';
		const textColor = this.isExporting ? 'rgba(0,0,0,1)' : 'rgba(0,0,0,.55)';

		const fontSize = 12;
		const tickLen = 10;

		const gap = 3;

		const maxAxisY = size.y - (tickLen + 18);
		const minAxisY = axisTop + 40;

		const axisY = Math.round(Math.min(maxAxisY, Math.max(minAxisY, yBaseRaw)));

		const eixoLinhas = `
  <!-- esquerda -->
  <div style="
    position:absolute;
    left:${axisX}px;
    top:${axisTop}px;
    width:1px;
    height:${Math.max(0, axisY - axisTop)}px;
    background:${lineColor};
  "></div>

  <!-- baixo -->
  <div style="
    position:absolute;
    left:${axisX}px;
    top:${axisY}px;
    height:1px;
    width:${Math.max(0, axisRight - axisX)}px;
    background:${lineColor};
  "></div>

  <!-- cima (NOVO) -->
  <div style="
    position:absolute;
    left:${axisX}px;
    top:${axisTop}px;
    height:1px;
    width:${Math.max(0, axisRight - axisX)}px;
    background:${lineColor};
  "></div>

  <!-- direita (NOVO) -->
  <div style="
    position:absolute;
    left:${axisRight}px;
    top:${axisTop}px;
    width:1px;
    height:${Math.max(0, axisY - axisTop)}px;
    background:${lineColor};
  "></div>
`;

		const ticksY = this.coordenadasRef.eixoVertical
			.map(t => {
				const yRaw = map.latLngToContainerPoint([t.lat, center.lng]).y;
				if (yRaw < axisTop - 80 || yRaw > axisY + 80) return '';

				const y = Math.round(Math.min(axisY, Math.max(axisTop, yRaw)));

				const xLabel = axisX - tickLen - gap;

				return `
      <!-- label (wrapper posiciona; filho rotaciona) -->
      <div style="
        position:absolute;
        left:${xLabel}px;
        top:${y}px;
        transform: translate(-100%,-50%);
        color:${textColor};
        font-size:${fontSize}px;
        line-height:1;
        white-space:nowrap;
      ">
        <span style="
          display:inline-block;
          transform: rotate(-90deg);
          transform-origin: 100% 50%;
        ">${t.label}</span>
      </div>

      <!-- tick -->
      <div style="
        position:absolute;
        left:${axisX}px;
        top:${y}px;
        width:${tickLen}px;
        height:1px;
        background:${lineColor};
        transform:translateY(-50%);
      "></div>
    `;
			})
			.join('');

		const ticksX = this.coordenadasRef.eixoHorizontal
			.map((t: { lng: number; label: string }) => {
				const xRaw = map.latLngToContainerPoint([center.lat, t.lng]).x;

				if (xRaw < axisX - 80 || xRaw > axisRight + 80) return '';

				const x = Math.round(Math.min(axisRight, Math.max(axisX, xRaw)));

				return `
        <div style="
          position:absolute;
          left:${x}px;
          top:${axisY - tickLen}px;
          width:1px;
          height:${tickLen}px;
          background:${lineColor};
          transform:translateX(-50%);
        "></div>

        <div style="
          position:absolute;
          left:${x}px;
          top:${axisY + tickLen + -5}px;
          transform:translateX(-50%);
          color:${textColor};
          font-size:${fontSize}px;
          line-height:1;
          white-space:nowrap;
        ">${t.label}</div>
      `;
			})
			.join('');

		const midY = Math.round((axisTop + axisY) / 2);
		const midX = Math.round((axisX + axisRight) / 2);

		const titulosEixos = this.isExporting
			? `
		<!-- Latitude (eixo Y) -->
		<div style="
			position:absolute;
			left:${axisX - 30}px;
			top:${midY}px;
			transform: translate(-100%,-50%) rotate(-90deg);
			transform-origin: 100% 50%;
			color:${textColor};
			font-size:${fontSize + 2}px;
			font-weight:0;
			white-space:nowrap;
		">Latitude</div>

		<!-- Longitude (eixo X) -->
		<div style="
			position:absolute;
			left:${midX}px;
			top:${axisY + tickLen + 12}px;
			transform: translateX(-50%);
			color:${textColor};
			font-size:${fontSize + 2}px;
			font-weight:350;
			white-space:nowrap;
		">Longitude</div>
	`
			: '';

		this.coordOverlayEl.innerHTML = `${eixoLinhas}${ticksY}${ticksX}${titulosEixos}`;
	}
	private aplicarRosaDosVentos(map: Leaflet.Map) {
		if (this.compassOverlayEl) this.compassOverlayEl.remove();
		if (this.compassOverlayCleanup) this.compassOverlayCleanup();

		const container = map.getContainer() as HTMLElement;
		if (getComputedStyle(container).position === 'static') {
			container.style.position = 'relative';
		}

		const overlay = document.createElement('div');
		overlay.className = 'mapa-rosa-ventos-overlay';

		overlay.style.position = 'absolute';
		overlay.style.right = '95px';
		overlay.style.top = '30px';
		overlay.style.left = 'auto';

		overlay.style.width = '60px';
		overlay.style.height = '60px';
		overlay.style.pointerEvents = 'none';
		overlay.style.zIndex = '9999';

		container.appendChild(overlay);
		this.compassOverlayEl = overlay;

		const render = () => this.renderizarRosaDosVentos();
		map.whenReady(() => render());
		map.on('resize', render);

		this.compassOverlayCleanup = () => {
			map.off('resize', render);
		};
	}

	private renderizarRosaDosVentos() {
		if (!this.compassOverlayEl) return;

		const preto = '#111827';

		const cinza = '#9CA3AF';

		this.compassOverlayEl.innerHTML = `
  <svg viewBox="0 0 100 100" width="60" height="60" style="display:block;">

    <!-- círculo -->
    <circle cx="50" cy="52" r="32" fill="none" stroke="${cinza}" stroke-width="2"/>

    <!-- estrela (pontas principais) -->
    <polygon points="50,18 57,52 50,86 43,52"
      fill="${cinza}"/>
    <polygon points="18,52 50,59 82,52 50,45"
      fill="${cinza}"/>

    <!-- pontas diagonais (cinza) -->
    <polygon points="50,26 54,52 50,78 46,52"
      fill="${cinza}" opacity="0.9" transform="rotate(45 50 52)"/>

    <!-- miolo -->
    <circle cx="50" cy="52" r="4" fill="${cinza}"/>

    <!-- letras (PT-BR) -->
    <text x="50" y="10" text-anchor="middle" font-size="11" font-weight="700" fill="${preto}">N</text>

    <text x="76" y="22" text-anchor="middle" font-size="10" font-weight="700" fill="${preto}">NE</text>
    <text x="24" y="22" text-anchor="middle" font-size="10" font-weight="700" fill="${preto}">NO</text>

    <text x="92" y="55" text-anchor="middle" font-size="11" font-weight="700" fill="${preto}">L</text>
    <text x="8"  y="55" text-anchor="middle" font-size="11" font-weight="700" fill="${preto}">O</text>

    <text x="76" y="92" text-anchor="middle" font-size="10" font-weight="700" fill="${preto}">SE</text>
    <text x="24" y="92" text-anchor="middle" font-size="10" font-weight="700" fill="${preto}">SO</text>

    <text x="50" y="99" text-anchor="middle" font-size="11" font-weight="700" fill="${preto}">S</text>
  
  </svg>
  `;
	}

	private async recortarDataUrlSides(
		dataUrl: string,
		rect: { x: number; y: number; w: number; h: number },
		pad: { top?: number; right?: number; bottom?: number; left?: number } = {}
	): Promise<string> {
		const img = await this.carregarImagem(dataUrl);

		const top = pad.top ?? 0;
		const right = pad.right ?? 0;
		const bottom = pad.bottom ?? 10;
		const left = pad.left ?? 0;

		const sx = Math.max(0, Math.floor(rect.x - left));
		const sy = Math.max(0, Math.floor(rect.y - top));
		const sw = Math.min(
			img.naturalWidth - sx,
			Math.floor(rect.w + left + right)
		);
		const sh = Math.min(
			img.naturalHeight - sy,
			Math.floor(rect.h + top + bottom)
		);

		const out = document.createElement('canvas');
		out.width = sw;
		out.height = sh;

		const ctx = out.getContext('2d')!;
		ctx.drawImage(img, sx, sy, sw, sh, 0, 0, sw, sh);

		return out.toDataURL('image/png', 1);
	}
	private isMobileViewport(): boolean {
		return window.matchMedia('(max-width: 768px)').matches;
	}

	private removerOverlays() {
		if (this.coordOverlayEl) this.coordOverlayEl.remove();
		if (this.coordOverlayCleanup) this.coordOverlayCleanup();
		this.coordOverlayEl = undefined;
		this.coordOverlayCleanup = undefined;

		if (this.compassOverlayEl) this.compassOverlayEl.remove();
		if (this.compassOverlayCleanup) this.compassOverlayCleanup();
		this.compassOverlayEl = undefined;
		this.compassOverlayCleanup = undefined;
	}

	private ajustarViewProporcionalAoGeoJSON(bounds?: Leaflet.LatLngBounds) {
		if (!this.map || !bounds) return;

		this.map.invalidateSize(true);

		this.map.fitBounds(bounds, {
			paddingTopLeft: Leaflet.point(12, 12),
			paddingBottomRight: Leaflet.point(12, 12),
			animate: false,
		});

		const z = this.map.getZoom();
		this.map.setMinZoom(z);
		this.map.setMaxZoom(z);
	}
	private ajustarMapaMobile(bounds?: Leaflet.LatLngBounds) {
		if (!this.map || !bounds || !bounds.isValid()) return;

		requestAnimationFrame(() => {
			this.map.invalidateSize(true);

			this.map.fitBounds(bounds, {
				paddingTopLeft: Leaflet.point(10, 10),
				paddingBottomRight: Leaflet.point(10, 10),
				animate: false,
			});

			const z = this.map.getZoom();
			this.map.setMinZoom(z);
			this.map.setMaxZoom(z);
		});
	}

	private fitMapToBounds() {
		if (!this.map || !this.geoJsonLayer) return;
		const bounds = this.geoJsonLayer.getBounds();
		if (bounds && bounds.isValid()) {
			this.map.invalidateSize(true);
			this.map.fitBounds(bounds, {
				paddingTopLeft: Leaflet.point(80, 20),
				paddingBottomRight: Leaflet.point(86, 60),
				animate: false,
			});
		}
	}

	private removerMascaraDoMapa() {
		if (this.maskLayer) {
			this.maskLayer.remove();
			this.maskLayer = undefined;
		}
	}
	private esconderElementosDaExportacao(): void {
		const seletores = [
			'.leaflet-control-container',
			'.leaflet-top',
			'.leaflet-bottom',
		];

		seletores.forEach(seletor => {
			document.querySelectorAll(seletor).forEach((el: Element) => {
				(el as HTMLElement).style.display = 'none';
			});
		});
	}

	private mostrarElementosDaExportacao(): void {
		const seletores = [
			'.leaflet-control-container',
			'.leaflet-top',
			'.leaflet-bottom',
		];

		seletores.forEach(seletor => {
			document.querySelectorAll(seletor).forEach((el: Element) => {
				(el as HTMLElement).style.display = '';
			});
		});
	}
}
